import { Box, CircularProgress, Typography } from "@mui/material";

interface RouteGuardLoadingStateProps {
  message: string;
}

const RouteGuardLoadingState = ({ message }: RouteGuardLoadingStateProps) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        bgcolor: "background.default",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: "100vh",
        p: 3,
      }}
    >
      <CircularProgress size={48} />
      <Typography
        sx={{
          color: "text.secondary",
          mt: 2,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default RouteGuardLoadingState;
